// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* fallow-ignore-file */
.PX5h2Lnba2K9_dRB1sdf {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: var(--campaign-tab-width);
  max-width: 100%;
  margin: 0 18px;
  filter: drop-shadow(0 0 37.5px rgba(60, 255, 0, 0.6));
}
.Yxi8MWPNHhNWMSHHD3Rg {
  position: relative;
  flex: 1 1 0;
}
/* Leading starting-point pill: round icon, no level/percent. */
.IfBIuDho8zTT24tm7Iht {
  position: relative;
  flex: 0 0 auto;
  width: 33px;
  height: 33px;
  margin: 0 -3px 0 0;
  z-index: 1;
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
  .IfBIuDho8zTT24tm7Iht {
    width: 22px;
    height: 22px;
  }
}
.uTfioDis4qIr1Cv_rrYr {
  position: relative;
  flex: 0 0 auto;
  width: 33px;
  height: 33px;
  /* Tuck the neighbouring bar segments slightly UNDER the pill (it's opaque at
     the track's height) so no gap shows between a segment and the pill.
     z-index keeps the pill above the segment that FOLLOWS it in the DOM too. */
  margin: 0 -3px;
  z-index: 1;
  /* The bar ends on the last level's pill — nothing to tuck under on its right. */
}
.uTfioDis4qIr1Cv_rrYr:last-child {
  margin-right: 0;
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
  .uTfioDis4qIr1Cv_rrYr {
    height: 22px;
    width: 22px;
  }
}
.VIr0nC2hjUlBcKDNk_04 {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
}
.VIr0nC2hjUlBcKDNk_04[data-status='finished'] {
  filter: drop-shadow(0 0 5.5px #3CFF00);
}
.VIr0nC2hjUlBcKDNk_04[data-status='unlocked'] {
  filter: drop-shadow(0 0 5.5px rgba(255, 255, 0, 0.5));
}
.Z9Dmpm5Y5pFZtld5o5e9 {
  position: absolute;
  top: -24px;
  display: flex;
  align-items: center;
  font-family: var(--font-family-secondary, inherit);
  font-size: 19.5px;
  font-weight: 700;
  letter-spacing: 0.375px;
  white-space: nowrap;
}
.Z9Dmpm5Y5pFZtld5o5e9[data-pill-status='unlocked'],
.Z9Dmpm5Y5pFZtld5o5e9[data-pill-status='finished'] {
  color: #fff;
}
.Z9Dmpm5Y5pFZtld5o5e9[data-pill-status='locked'] {
  color: #d3d3d3;
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
  .Z9Dmpm5Y5pFZtld5o5e9 {
    font-size: 13px;
    letter-spacing: 0.25px;
    top: -17px;
  }
}
/* More than one campaign */
[data-has-many='true'] .PX5h2Lnba2K9_dRB1sdf {
  margin: 0 24px;
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
  [data-has-many='true'] .PX5h2Lnba2K9_dRB1sdf {
    margin: 0 16px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/campaigns/components/variants/rebate/RebateCard/components/RebateProgressBar/RebateProgressBar.module.css"],"names":[],"mappings":"AAAA,uBAAuB;AACvB;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,gCAAgC;EAChC,eAAe;EACf,cAAc;EACd,qDAAqD;AACvD;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA,+DAA+D;AAC/D;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE;IACE,WAAW;IACX,YAAY;EACd;AACF;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,YAAY;EACZ;;+EAE6E;EAC7E,cAAc;EACd,UAAU;EACV,gFAAgF;AAClF;AACA;EACE,eAAe;AACjB;AACA;EACE;IACE,YAAY;IACZ,WAAW;EACb;AACF;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;AACd;AACA;EACE,sCAAsC;AACxC;AACA;EACE,qDAAqD;AACvD;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,kDAAkD;EAClD,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;;EAEE,WAAW;AACb;AACA;EACE,cAAc;AAChB;AACA;EACE;IACE,eAAe;IACf,sBAAsB;IACtB,UAAU;EACZ;AACF;AACA,2BAA2B;AAC3B;EACE,cAAc;AAChB;AACA;EACE;IACE,cAAc;EAChB;AACF","sourcesContent":["/* fallow-ignore-file */\n.rebateProgressBar {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  width: var(--campaign-tab-width);\n  max-width: 100%;\n  margin: 0 18px;\n  filter: drop-shadow(0 0 37.5px rgba(60, 255, 0, 0.6));\n}\n.segment {\n  position: relative;\n  flex: 1 1 0;\n}\n/* Leading starting-point pill: round icon, no level/percent. */\n.startPill {\n  position: relative;\n  flex: 0 0 auto;\n  width: 33px;\n  height: 33px;\n  margin: 0 -3px 0 0;\n  z-index: 1;\n}\n@media (--campaign-mobile) {\n  .startPill {\n    width: 22px;\n    height: 22px;\n  }\n}\n.pill {\n  position: relative;\n  flex: 0 0 auto;\n  width: 33px;\n  height: 33px;\n  /* Tuck the neighbouring bar segments slightly UNDER the pill (it's opaque at\n     the track's height) so no gap shows between a segment and the pill.\n     z-index keeps the pill above the segment that FOLLOWS it in the DOM too. */\n  margin: 0 -3px;\n  z-index: 1;\n  /* The bar ends on the last level's pill — nothing to tuck under on its right. */\n}\n.pill:last-child {\n  margin-right: 0;\n}\n@media (--campaign-mobile) {\n  .pill {\n    height: 22px;\n    width: 22px;\n  }\n}\n.pillIcon {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n}\n.pillIcon[data-status='finished'] {\n  filter: drop-shadow(0 0 5.5px #3CFF00);\n}\n.pillIcon[data-status='unlocked'] {\n  filter: drop-shadow(0 0 5.5px rgba(255, 255, 0, 0.5));\n}\n.pillPercent {\n  position: absolute;\n  top: -24px;\n  display: flex;\n  align-items: center;\n  font-family: var(--font-family-secondary, inherit);\n  font-size: 19.5px;\n  font-weight: 700;\n  letter-spacing: 0.375px;\n  white-space: nowrap;\n}\n.pillPercent[data-pill-status='unlocked'],\n.pillPercent[data-pill-status='finished'] {\n  color: #fff;\n}\n.pillPercent[data-pill-status='locked'] {\n  color: #d3d3d3;\n}\n@media (--campaign-mobile) {\n  .pillPercent {\n    font-size: 13px;\n    letter-spacing: 0.25px;\n    top: -17px;\n  }\n}\n/* More than one campaign */\n[data-has-many='true'] .rebateProgressBar {\n  margin: 0 24px;\n}\n@media (--campaign-mobile) {\n  [data-has-many='true'] .rebateProgressBar {\n    margin: 0 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"rebateProgressBar": `PX5h2Lnba2K9_dRB1sdf`,
	"segment": `Yxi8MWPNHhNWMSHHD3Rg`,
	"startPill": `IfBIuDho8zTT24tm7Iht`,
	"pill": `uTfioDis4qIr1Cv_rrYr`,
	"pillIcon": `VIr0nC2hjUlBcKDNk_04`,
	"pillPercent": `Z9Dmpm5Y5pFZtld5o5e9`
};
export default ___CSS_LOADER_EXPORT___;
